import React from 'react';

const TestimonialsSection = ({ section }) => {
  const sectionData = section.section_data || {};
  const testimonials = sectionData.testimonials || [];
  const columns = sectionData.columns || 3;
  const showRating = sectionData.show_rating !== false;
  const showImage = sectionData.show_image !== false;

  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  if (testimonials.length === 0) {
    return null;
  }

  return (
    <section
      className="testimonials-section"
      style={{
        backgroundColor: section.background_color || '#f8f9fa',
        color: section.text_color || '#000000',
        padding: '60px 20px'
      }}
    >
      <div className="container">
        {section.title && (
          <h2 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', textAlign: 'center', fontWeight: '600' }}>
            {section.title}
          </h2>
        )}
        {section.subtitle && (
          <p style={{ fontSize: '1.2rem', marginBottom: '3rem', textAlign: 'center', opacity: 0.8 }}>
            {section.subtitle}
          </p>
        )}

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: '30px'
          }}
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              style={{
                backgroundColor: '#ffffff',
                padding: '30px',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 12px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
              }}
            >
              {showRating && testimonial.rating && (
                <div style={{ color: '#ffc107', fontSize: '1.3rem', marginBottom: '1rem' }}>
                  {renderStars(testimonial.rating)}
                </div>
              )}
              
              {testimonial.quote && (
                <p style={{ fontSize: '1.1rem', lineHeight: '1.7', marginBottom: '1.5rem', fontStyle: 'italic', color: '#555' }}>
                  "{testimonial.quote}"
                </p>
              )}

              <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '1.5rem' }}>
                {showImage && testimonial.image && (
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      objectFit: 'cover'
                    }}
                  />
                )}
                <div>
                  {testimonial.name && (
                    <div style={{ fontWeight: 'bold', fontSize: '1rem', marginBottom: '4px' }}>
                      {testimonial.name}
                    </div>
                  )}
                  {(testimonial.position || testimonial.company) && (
                    <div style={{ fontSize: '0.9rem', color: '#666' }}>
                      {testimonial.position && testimonial.company
                        ? `${testimonial.position} at ${testimonial.company}`
                        : testimonial.position || testimonial.company}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
